import { assert } from '@lingoda/utils';
import { useSelector } from './useSelector';

export const useSelectOrFail = <TState, TSelected>(
    selector: (state: TState) => TSelected | undefined | null,
): TSelected => {
    const selected = useSelector<TState, TSelected | null | undefined>(selector);

    assert(selected, 'Invalid argument');

    return selected;
};
